import getSidebarItems from './other';

const userData = JSON.parse(localStorage.getItem('userData'));
const role = userData?.role || 'default';

// roleBasedItems'te karşılığı olmayan rol (ör. eski oturumun 'ortherouser'ı) →
// adviser menüsüne düş; tanımsız rol boş drawer üretmesin.
const FALLBACK_ROLES = { ortherouser: 'ortheroadviser', adviser: 'ortheroadviser' };
const resolvedRole = FALLBACK_ROLES[role] || role;

const menuItems = {
    items: [getSidebarItems(resolvedRole)]
};

export default menuItems;
